(function () {
  var section = document.querySelector('[data-qt-get-to-us]');
  if (!section) return;
  var planeDesktop = section.querySelector('[data-qt-plane]');
  var planeMobile  = section.querySelector('[data-qt-plane-mobile]');
  var row          = section.querySelector('[data-qt-plane-row]');
  var isMobile = function () { return window.innerWidth < 768; };
  function getSectionProgress() {
    var rect       = section.getBoundingClientRect();
    var vh         = window.innerHeight;
    var totalRange = vh * 0.8;
    var progress   = (vh * 0.85 - rect.top) / totalRange;
    return Math.max(0, Math.min(1, progress));
  }

  function animatePlane() {
    var p = getSectionProgress();
    if (!isMobile() && planeDesktop && row) {
        var rowWidth = row.offsetWidth;
        var startX = rowWidth * 0.15;
        var endX   = rowWidth * 0.85;
        var startY = 100;
        var endY   = -180;
        var x = startX + p * (endX - startX);
        var y = startY + p * (endY - startY);
        planeDesktop.style.transform = 'translateX(' + x + 'px) translateY(' + y + 'px) rotate(-25deg)';
    }
    if (isMobile() && planeMobile) {
      var pw = planeMobile.offsetWidth + 50;
      console.log(pw)
        var mStartX = 50;
        var mEndX   = 0;
        var mx      = mStartX + p * (mEndX - mStartX);
        planeMobile.style.transform = 'translateX(' + mx + 'px) scaleX(-1) rotate(-20deg)';
    }
  }
  window.addEventListener('scroll', animatePlane, { passive: true });
  window.addEventListener('resize', animatePlane, { passive: true });
  animatePlane();
})();